import { byMethod } from '@oysterjs/core/graphql/actions';
import { merge } from '@oysterjs/core/graphql/loaders';
import type { RouteObject } from 'react-router-dom';
import {
  submitArchiveHtmlDocumentTemplates,
  submitCreateHtmlDocumentTemplate,
  submitUpdateHtmlDocumentTemplate,
  submitUpdateHtmlDocumentTemplatesVisibility
} from '~/api/data/html-templates/mutations';
import {
  loadHtmlDocumentTemplate,
  loadHtmlDocumentTemplates
} from '~/api/data/html-templates/queries';
import { LibraryStylesPage, StyleCreatePage, StyleEditPage } from '~/pages/library/styles';

const stylesLibraryChildren = [
  {
    path: 'archive',
    action: byMethod({
      POST: submitArchiveHtmlDocumentTemplates
    })
  },
  {
    path: 'visibility',
    action: byMethod({
      POST: submitUpdateHtmlDocumentTemplatesVisibility
    })
  },
  {
    path: 'new',
    action: byMethod({
      POST: submitCreateHtmlDocumentTemplate
    }),
    element: <StyleCreatePage />
  },
  {
    path: ':id',
    loader: merge({
      htmlDocumentTemplate: loadHtmlDocumentTemplate,
      htmlDocumentTemplates: loadHtmlDocumentTemplates
    }),
    action: byMethod({
      PUT: submitUpdateHtmlDocumentTemplate
    }),
    element: <StyleEditPage />
  }
];

export const stylesRoute: RouteObject = {
  path: 'styles',
  loader: merge({
    htmlDocumentTemplates: loadHtmlDocumentTemplates
  }),
  element: <LibraryStylesPage />,
  children: stylesLibraryChildren
};
